import React from 'react';

import loadable from '@loadable/component'

import NavBar from './Components/NavBar'
import Hero from './Components/Hero';
import Footer from './Components/Footer';
import ReactGA from 'react-ga';

import ButtonsLine from './Components/ButtonsLine';
import LazyLoad from 'react-lazyload';
import News from './Components/News';

const Web = loadable(() => import('./Components/Projects/Web'))
const Mobile = loadable(() => import('./Components/Projects/Mobile'))
const Photography = loadable(() => import('./Components/Photography'))
const MachineLearningAndComputerGraphics = loadable(() => import('./Components/Projects/MachineLearningAndComputerGraphics'))
const DesignAndOther = loadable(() => import('./Components/Projects/DesignAndOther'))

var Scroll = require('react-scroll');
var Element = Scroll.Element;
//var scroller = Scroll.scroller;


function App() {

  ReactGA.initialize('UA-159431690-1');
  ReactGA.pageview(window.location.pathname + window.location.search);
  return (
    <div style={{backgroundColor:'#e7e7e7'}}>
      <NavBar />
        <Hero />
        <ButtonsLine />
        <News />
        <Element name="Web">
        <LazyLoad height={200} once offset={100}>
          <Web />
        </LazyLoad>
        </Element>
        <Element name="Mobile">
        <LazyLoad height={200}  once offset={300}>
          <Mobile />
        </LazyLoad>
        </Element>
        <Element name="ML">
        <LazyLoad height={200}  once offset={300}>
          <MachineLearningAndComputerGraphics />
        </LazyLoad>
        </Element>
        <Element name="DesignAndOther">
        <LazyLoad height={200}  once offset={300}>
          <DesignAndOther />
        </LazyLoad>
        </Element>
        <Element name="Photography">
        <LazyLoad height={200}  once offset={300}>
          <Photography />
        </LazyLoad>
        </Element>

      <Footer />
  
    </div>
  );
}

export default App;
